import { useCallback, useEffect, useState } from "react";
import { Archive, Bot, Pencil, Plus } from "lucide-react";
import { Modal } from "../../components/common";
import { api, errMsg, idr } from "../../lib/api";

const EAForm = ({ initial, onClose, onSaved }) => {
  const [form, setForm] = useState({ platform: "MT5", ...(initial || { name: "", description: "", monthly: 499000, tag: "", active: true }) });
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    const body = { name: form.name, description: form.description, monthly: Number(form.monthly), tag: form.tag, platform: form.platform, active: form.active };
    try {
      if (initial) await api.put(`/admin/ea/${initial.id}`, body);
      else await api.post("/admin/ea", body);
      onSaved();
    } catch (err) {
      setError(errMsg(err, "Data EA belum valid"));
    }
  };
  return (
    <Modal onClose={onClose} testId="ea-form-modal">
      <form onSubmit={save}>
        <p className="eyebrow">KATALOG EA</p>
        <h3>{initial ? "Ubah EA" : "Tambah EA baru"}</h3>
        <label>Nama EA<input required value={form.name} onChange={set("name")} data-testid="ea-name-input" /></label>
        <label>Deskripsi<input required value={form.description} onChange={set("description")} data-testid="ea-description-input" /></label>
        <label>Platform EA
          <select value={form.platform} onChange={set("platform")} data-testid="ea-platform-select"><option value="MT5">MT5</option><option value="MT4">MT4</option></select>
        </label>
        <label>Harga sewa 30 hari (Rp)<input required type="number" min="1000" value={form.monthly} onChange={set("monthly")} data-testid="ea-price-input" /></label>
        <label>Label (opsional)<input value={form.tag} placeholder="Paling populer" onChange={set("tag")} data-testid="ea-tag-input" /></label>
        <label className="check"><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} data-testid="ea-active-checkbox" /> Tampilkan ke member</label>
        {error && <div className="error" data-testid="ea-form-error">{error}</div>}
        <button className="primary full" data-testid="ea-save-button">Simpan</button>
      </form>
    </Modal>
  );
};

export default function AdminEA() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = useCallback(() => api.get("/admin/ea").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const archive = async (e) => {
    if (!window.confirm(`Sembunyikan ${e.name} dari katalog member?`)) return;
    await api.delete(`/admin/ea/${e.id}`);
    load();
  };
  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">ADMIN · PRODUK</p><h2>Katalog EA</h2><p className="muted">Atur EA, deskripsi, dan harga sewa 30 hari yang tampil di menu Sewa EA.</p></div>
        <button className="primary" onClick={() => setEditing("new")} data-testid="admin-add-ea-button"><Plus size={16} /> Tambah EA</button>
      </div>
      <div className="ea-grid">
        {items.map((e) => (
          <div className={e.active ? "ea-card" : "ea-card archived"} key={e.id} data-testid={`admin-ea-card-${e.id}`}>
            <div className="ea-card-top"><div className="bot-icon"><Bot size={25} /></div><span>{e.active ? e.tag || "AKTIF" : "DISEMBUNYIKAN"}</span></div>
            <h3>{e.name} <span className="platform-tag" data-testid={`admin-ea-platform-${e.id}`}>{e.platform || "MT5"}</span></h3>
            <p className="muted">{e.description}</p>
            <div className="ea-price"><strong>{idr(e.monthly)}</strong><small>/ 30 hari</small></div>
            <div className="row-actions">
              <button className="outline" onClick={() => setEditing(e)} data-testid={`admin-edit-ea-${e.id}`}><Pencil size={14} /> Ubah</button>
              {e.active && <button className="outline" onClick={() => archive(e)} data-testid={`admin-archive-ea-${e.id}`}><Archive size={14} /> Sembunyikan</button>}
            </div>
          </div>
        ))}
      </div>
      {editing && <EAForm initial={editing === "new" ? null : editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </>
  );
}
